export default function (verticalSlug) {
  switch (verticalSlug) {
    case 'globalcitizen':
      return 'Global Citizen';

    case 'knowyourvalue':
      return 'Know Your Value';

    case 'leftfield':
      return 'Left Field';

    case 'noticias':
      return 'Noticias Telemundo';

    default:
      return verticalSlug
        ? `${verticalSlug.charAt(0).toUpperCase()}${verticalSlug.slice(1)}`
        : 'News';
  }
}
